import { nanoid } from 'nanoid';
import type { Character } from '../../../types/character';
import { SkillsService } from '../../../services/SkillsService';
import { rulebookService } from '../../../services/RulebookService';

// Default character creation data
export const createDefault = (name: string): Character => {
  const now = new Date();

  return {
    id: nanoid(),
    name,
    career: {
      id: '',
      name: '',
      description: '',
      startingSkills: [],
      startingTalents: [],
      startingEquipment: [],
      aptitudes: [],
      rulebook: ''
    },
    homeworld: {
      id: '',
      name: '',
      description: '',
      characteristicModifiers: {},
      startingSkills: [],
      startingTalents: [],
      startingTraits: [],
      startingEquipment: [],
      rulebook: ''
    },
    birthright: {
      id: '',
      name: '',
      description: '',
      benefit: '',
      rulebook: ''
    },
    lure: {
      id: '',
      name: '',
      description: '',
      benefit: '',
      rulebook: ''
    },
    trials: {
      id: '',
      name: '',
      description: '',
      benefit: '',
      rulebook: ''
    },
    motivation: {
      id: '',
      name: '',
      description: '',
      benefit: '',
      rulebook: ''
    },
    characteristics: {
      weaponSkill: 30,
      ballisticSkill: 30,
      strength: 30,
      toughness: 30,
      agility: 30,
      intelligence: 30,
      perception: 30,
      willpower: 30,
      fellowship: 30,
      influence: 30
    },
    derivedStats: {
      wounds: 0,
      fatigue: 0,
      corruption: 0,
      insanity: 0,
      profitFactor: 0,
      initiative: 0,
      movementHalf: 0,
      movementFull: 0,
      movementCharge: 0,
      movementRun: 0
    },
    experience: {
      total: 0,
      spent: 0,
      available: 0
    },
    skills: SkillsService.initializeBasicSkills(rulebookService.getEnabledRulebookIds()),
    talents: [],
    traits: [],
    equipment: [],
    weapons: [],
    armor: [],
    enabledRulebooks: rulebookService.getEnabledRulebookIds(),
    manualAdjustments: [],
    conditionalModifiers: [],
    schemaVersion: 1,
    createdAt: now,
    lastModified: now
  };
};
